import useSlideOver from 'components/SlideOver/useSlideOver';
import UseContext from 'hooks/useContext';

/**
 * Opens a record of the admin in its side panel, as its own list does:
 * `openPanel('get_mission', missionId)`, `openPanel('get_temp_worker', userId)`.
 */
const useOpenPanel = () => {
  const { setObjID } = UseContext();
  const { toggleSlideOver } = useSlideOver();
  return (type, id) => {
    setObjID(id);
    toggleSlideOver(type);
  };
};

export default useOpenPanel;
